import {
  FiActivity,
  FiBatteryCharging,
  FiBluetooth,
  FiCamera,
  FiClock,
  FiCloud,
  FiCode,
  FiCompass,
  FiCpu,
  FiCrosshair,
  FiDatabase,
  FiDroplet,
  FiEye,
  FiGlobe,
  FiGrid,
  FiHardDrive,
  FiLayers,
  FiLink,
  FiLock,
  FiMapPin,
  FiMic,
  FiMonitor,
  FiPackage,
  FiPhone,
  FiPower,
  FiPrinter,
  FiRadio,
  FiRefreshCw,
  FiServer,
  FiSettings,
  FiShield,
  FiSliders,
  FiSpeaker,
  FiSun,
  FiTarget,
  FiThermometer,
  FiTool,
  FiTruck,
  FiVideo,
  FiWatch,
  FiWifi,
  FiWind,
  FiZap,
} from 'react-icons/fi';

import {
  FiAnchor,
  FiAperture,
  FiBell,
  FiCheckCircle,
  FiCommand,
  FiDisc,
  FiDownload,
  FiFeather,
  FiFilter,
  FiFlag,
  FiGitBranch,
  FiLifeBuoy,
  FiMaximize,
  FiNavigation,
  FiPieChart,
  FiRepeat,
  FiRss,
  FiSend,
  FiSmartphone,
  FiTerminal,
  FiUmbrella,
  FiUpload,
} from 'react-icons/fi';

export const PRODUCT_FEATURE_ICONS = [
  { value: 'cpu', label: 'Processor', Icon: FiCpu },
  { value: 'monitor', label: 'Display', Icon: FiMonitor },
  { value: 'wifi', label: 'Wi-Fi', Icon: FiWifi },
  { value: 'battery', label: 'Battery', Icon: FiBatteryCharging },
  { value: 'sliders', label: 'Controls', Icon: FiSliders },
  { value: 'shield', label: 'Protection', Icon: FiShield },
  { value: 'hard-drive', label: 'Storage', Icon: FiHardDrive },
  { value: 'zap', label: 'Power', Icon: FiZap },
  { value: 'settings', label: 'Configuration', Icon: FiSettings },
  { value: 'tool', label: 'Tool', Icon: FiTool },
  { value: 'activity', label: 'Performance', Icon: FiActivity },
  { value: 'bluetooth', label: 'Bluetooth', Icon: FiBluetooth },
  { value: 'camera', label: 'Camera', Icon: FiCamera },
  { value: 'clock', label: 'Time / speed', Icon: FiClock },
  { value: 'cloud', label: 'Cloud', Icon: FiCloud },
  { value: 'code', label: 'Programming', Icon: FiCode },
  { value: 'compass', label: 'Orientation', Icon: FiCompass },
  { value: 'crosshair', label: 'Precision', Icon: FiCrosshair },
  { value: 'database', label: 'Database', Icon: FiDatabase },
  { value: 'droplet', label: 'Liquid / humidity', Icon: FiDroplet },
  { value: 'eye', label: 'Vision', Icon: FiEye },
  { value: 'globe', label: 'Network / global', Icon: FiGlobe },
  { value: 'grid', label: 'Modules', Icon: FiGrid },
  { value: 'layers', label: 'Layers / capacity', Icon: FiLayers },
  { value: 'link', label: 'Connectivity', Icon: FiLink },
  { value: 'lock', label: 'Security', Icon: FiLock },
  { value: 'map-pin', label: 'Location', Icon: FiMapPin },
  { value: 'mic', label: 'Microphone', Icon: FiMic },
  { value: 'package', label: 'Package', Icon: FiPackage },
  { value: 'phone', label: 'Phone', Icon: FiPhone },
  { value: 'power', label: 'Power button', Icon: FiPower },
  { value: 'printer', label: 'Printing', Icon: FiPrinter },
  { value: 'radio', label: 'Wireless signal', Icon: FiRadio },
  { value: 'refresh', label: 'Rotation / refresh', Icon: FiRefreshCw },
  { value: 'server', label: 'Server', Icon: FiServer },
  { value: 'speaker', label: 'Audio', Icon: FiSpeaker },
  { value: 'sun', label: 'Brightness', Icon: FiSun },
  { value: 'target', label: 'Target', Icon: FiTarget },
  { value: 'thermometer', label: 'Temperature', Icon: FiThermometer },
  { value: 'truck', label: 'Transport', Icon: FiTruck },
  { value: 'video', label: 'Video', Icon: FiVideo },
  { value: 'watch', label: 'Wearable', Icon: FiWatch },
  { value: 'wind', label: 'Air flow', Icon: FiWind },
  { value: 'anchor', label: 'Mounting / stability', Icon: FiAnchor },
  { value: 'aperture', label: 'Optics', Icon: FiAperture },
  { value: 'bell', label: 'Alarm / notification', Icon: FiBell },
  { value: 'check-circle', label: 'Certification / approval', Icon: FiCheckCircle },
  { value: 'command', label: 'Command / automation', Icon: FiCommand },
  { value: 'disc', label: 'Media / rotation', Icon: FiDisc },
  { value: 'download', label: 'Download / input', Icon: FiDownload },
  { value: 'feather', label: 'Lightweight', Icon: FiFeather },
  { value: 'filter', label: 'Filtering', Icon: FiFilter },
  { value: 'flag', label: 'Status / marker', Icon: FiFlag },
  { value: 'git-branch', label: 'Branching / I/O', Icon: FiGitBranch },
  { value: 'life-buoy', label: 'Support / safety', Icon: FiLifeBuoy },
  { value: 'maximize', label: 'Expansion / range', Icon: FiMaximize },
  { value: 'navigation', label: 'Navigation / direction', Icon: FiNavigation },
  { value: 'pie-chart', label: 'Analytics', Icon: FiPieChart },
  { value: 'repeat', label: 'Cycle / repeat', Icon: FiRepeat },
  { value: 'rss', label: 'Broadcast / telemetry', Icon: FiRss },
  { value: 'send', label: 'Transmission / output', Icon: FiSend },
  { value: 'smartphone', label: 'Mobile control', Icon: FiSmartphone },
  { value: 'terminal', label: 'Terminal / interface', Icon: FiTerminal },
  { value: 'umbrella', label: 'Weather protection', Icon: FiUmbrella },
  { value: 'upload', label: 'Upload / output', Icon: FiUpload },
];

export const PRODUCT_FEATURE_ICON_MAP = Object.fromEntries(
  PRODUCT_FEATURE_ICONS.map(({ value, Icon }) => [value, Icon])
);

export function parseProductFeatures(value) {
  if (Array.isArray(value)) return value;
  if (!value) return [];
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
}
